import CurrentLink from 'app/dodones/shared/CurrentLink'
import Dashboard from 'app/dodones/day/Dashboard'
import DodoablesDaysProofs from 'app/dodones/proofs/Index'
import DodoablesFree from 'app/dodoables/Free'
import DodoneContext from 'app/dodones/Context'
import DodoneFinishButton from 'app/dodones/shared/FinishButton'
import DodoneNextLink from 'app/dodones/shared/NextLink'
import DodoneStartButton from 'app/dodones/shared/StartButton'
import DodoneStats from 'app/dodones/shared/Stats'
import DodonesList from 'app/dodones/list/Index'
import DodonesListItem from 'app/dodones/list/Item'
import HeaderContext from 'app/HeaderContext'
import Spinning from 'app/components/Spinning'
import Tabs from 'app/components/tabs/Param'
import { format } from 'date-fns'

const Section = ({ section, dodones }) => {
  const isOngoing = useMemo(() => {
    return dodones.some((dodone) => {
      return dodone.isOngoing
    })
  }, [section, dodones])

  const isCompleted = useMemo(() => {
    return dodones.every((dodone) => {
      return dodone.isCompleted
    })
  }, [section, dodones])

  const conditionalClasses = {
    'text-blue-200 border-b-blue-400-50t': isOngoing,
    'text-green-300 border-b-green-400-50t': isCompleted,
    'text-gray-200 border-b-gray-400-50t': !isOngoing && !isCompleted
  }

  return (
    <>
      {section != 'unknown' && (
        <div className={clsx('text-center text-sm mb-2', conditionalClasses)}>
          {section}
        </div>
      )}
      <DodonesList dodones={dodones} />
    </>
  )
}

const Sections = ({ dodone }) => {
  const dodonesSections = useMemo(() => {
    const sectionMap = {}
    const sectionOrder = []

    dodone.children.forEach((child) => {
      const section = child.settings.section || 'unknown'
      sectionMap[section] ||= []
      sectionMap[section].push(child)

      if (sectionOrder.indexOf(section) == -1) {
        sectionOrder.push(section)
      }
    })

    return sectionOrder.map((section) => {
      return { section: section, dodones: sectionMap[section] }
    })
  }, [dodone])

  return (
    <div className="fcol flex-1">
      <div className="fcol flex-1" style={{ overflowY: 'scroll' }}>
        {dodonesSections.map((sectionItem) => {
          return <Section key={sectionItem.section} {...sectionItem} />
        })}
      </div>
    </div>
  )
}

const Header = ({ dodone }) => {
  const ongoingDodone = useMemo(() => {
    return dodone.children.find((child) => {
      return child.isOngoing
    })
  })

  return (
    <>
      <div className="italic mb-h text-center text-gray-900">
        Are you Dreaming?
      </div>

      {ongoingDodone ? (
        <DodonesListItem dodone={ongoingDodone} />
      ) : (
        <DodoneNextLink currentDodoneId={dodone.id} />
      )}
    </>
  )
}

const StartedDay = () => {
  const { dodone } = useContext(DodoneContext)
  const children = useMemo(() => {
    return dodone.children.sort((a, b) => {
      if (a.startedAt && b.startedAt) return a.startedAt - b.startedAt
      else if (a.startedAt && !b.startedAt) return -1
      else if (!a.startedAt && b.startedAt) return 1

      return a.order - b.order
    })
  }, [dodone])

  let tabs = [
    {
      key: 'dashboard',
      text: 'Dashboard',
      element: <Dashboard dodone={dodone} />
    },
    {
      key: 'today',
      text: 'Today',
      element: <DodonesList dodones={children} />
    },
    { key: 'free', text: 'Free', element: <DodoablesFree /> },
    {
      key: 'proofs',
      text: 'Proofs',
      element: <DodoablesDaysProofs dodone={dodone} />
    }
  ]

  const somePending = dodone.children.some((dodone) => {
    return dodone.pending
  })

  const now = new Date()
  const showFinishButton =
    !somePending &&
    !dodone.isFinished &&
    (now.getHours() > 19 ||
      dodone.day.getMonth() < now.getMonth() ||
      dodone.day.getDate() < now.getDate())

  return (
    <div className="fcol flex-1">
      <Tabs tabs={tabs} defaultTabKey="dashboard" />
      {showFinishButton ? <DodoneFinishButton text="Cabo o dia" /> : null}
    </div>
  )
}

const PreviousDayWarning = ({ dodone }) => {
  if (!dodone.isPrevious) return null

  return (
    <div className="mb-d">
      <div className="orange-transparent-box py-2">
        <div className="text-center pb-1 text-xl"> Esqueceu seu tonto </div>
        {dodone.isFinished ? (
          <div className="text-lg text-center">
            <CurrentLink />
          </div>
        ) : null}
      </div>
    </div>
  )
}

const FinishedDay = () => {
  const { dodone } = useContext(DodoneContext)

  return <DodoneStats dodone={dodone} />
}

export default () => {
  const { setText } = useContext(HeaderContext)
  const { dodone } = useContext(DodoneContext)

  useEffect(() => {
    setText(format(dodone.day, 'E, MMM dd'))
  }, [dodone.id])

  return (
    <>
      <Header dodone={dodone} />
      {dodone.isNotStarted ? (
        <>
          <div className="flex-1 fcol">
            <Sections dodone={dodone} />
          </div>
          <DodoneStartButton text="Start Day" />
        </>
      ) : null}
      {dodone.isStarted ? <StartedDay /> : null}
      {dodone.isFinished ? <FinishedDay /> : null}
    </>
  )
}
